import {fetcherGis} from "api/fetcher";
import {useEffect, useState} from "react";
import useSWRInfinite from "swr/infinite";
import {queries} from "shared/api/queries";
import {useAuth} from "features/login/context/AuthProvider";
import {Map} from "ol";
import Feature, {FeatureLike} from "ol/Feature";
import {GeoJSON} from "ol/format";
import {useLayer} from "@delivus-daas/react-open-layers";
import {Style} from "ol/style";
import {IZipcodeResponse} from "features/plan/types";

export const useZipcodes = (bound?: Array<number>, map?: Map, visible?: boolean, polygonStyle?: (feature: FeatureLike) => Style) => {
  const {authenticated} = useAuth();
  const [zipcodes, setZipcodes] = useState<Feature[]>();
  const getKey = (pageIndex: number, previousPageData: IZipcodeResponse) => {
    if (visible && authenticated && pageIndex === 0 && bound && bound?.length > 3) {
      return (queries.location.zipcode + `?page_size=300&include_geom=true&min_x=${bound[0]}&min_y=${bound[1]}&max_x=${bound[2]}&max_y=${bound[3]}`);
    }
    if (previousPageData && previousPageData.next) return queries.location.zipcode + previousPageData.next;
    return null; // reached the end
  };
  
  const {data, error, setSize} = useSWRInfinite<IZipcodeResponse>(getKey, fetcherGis, {
    initialSize: 1, revalidateOnFocus: false, revalidateIfStale: false, revalidateFirstPage: false,
  });
  
  useEffect(() => {
    if (data && data?.length > 0) {
      const lastRes = data[data?.length - 1];
      if (lastRes && lastRes.current_page * lastRes.items_per_page < lastRes.count) {
        setSize((size) => size + 1);
      }
      else {
        let features: any[] = [];
        data.forEach((item) => {
          if (item?.results) {
            features = features.concat(item.results);
          }
        });
        setZipcodes(new GeoJSON().readFeatures({
          "type": "FeatureCollection", features
        }, {
          featureProjection: 'EPSG:4326' // Important: map projection
        }));
      }
    }
  }, [data, setSize]);
  
  useLayer({
    map, name: "zipcodes", visible, features: zipcodes, layerOptions: {
      zIndex: 13,
    }, style: polygonStyle
  });
};
